import React, { useEffect, useState } from "react";
import { Row, Col, Card, Divider, Button } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./Plans.css";
import {
  setInvoice,
  setPlanMeAction,
  setPlansAction,
} from "../store/actions/user";
import Axios from "axios";
import constants from "../constants/constants.json";
import Message from "../helper/Message";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { plansAPI, planMeAPI } from "../apis/planApi";

export default function Plans(props) {
  const [loading, setLoading] = useState(true);
  const [loadingBuy, setLoadingBuy] = useState(false);

  const plans = useSelector((state) => state.userReducer.plans);
  const planMe = useSelector((state) => state.userReducer.plan);

  const [indexPlan, setIndexPlan] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const planList = async () => {
    setLoading(true);
    try {
      setLoading(true);
      await plansAPI(dispatch);
      await planMeAPI(dispatch);
      setLoading(false);
    } catch (err) {
      Message.error("Communication error");
      setLoading(false);
    }
  };

  const buyPlan = async (id) => {
    setLoadingBuy(true);
    setIndexPlan(id);
    try {
      const token = localStorage.getItem("pnsToken");
      let response = await Axios.get(constants.url + "/plan/upgrade/" + id, {
        headers: {
          authorization: "Bearer " + token,
        },
      });
      if (response.data.status === 202) {
        dispatch(setInvoice(response.data.result.invoice));
        history.push("/dashboard/checkout");
        setLoadingBuy(false);
        setIndexPlan(false);
      } else {
        Message.error(response.data.result.message);
        setLoadingBuy(false);
        setIndexPlan(false);
      }
    } catch (err) {
      Message.error("Communication error");
      setLoadingBuy(false);
      setIndexPlan(false);
    }
  };

  useEffect(() => {
    planList();
  }, []);

  return loading ? (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loading3QuartersOutlined
        spin
        style={{ fontSize: "24px", color: "white" }}
      />
    </div>
  ) : (
    <Row justify="center">
      <Col xs={24} sm={24} md={20} lg={18} xl={18}>
        <Card>
          <Divider style={{ margin: "0 0 20px 0" }}>Purchased Plan</Divider>
          {planMe ? (
            <Row>
              <Col span={8}>
                <span className="plans-font-name">{planMe.plan.name}</span>
              </Col>

              <Col className="plans-column-flex" span={8}>
                <div className="plans-date-container">
                  <span className="plans-font-date-buy-container">
                    Purchase Date :{" "}
                    <span>
                      {moment
                        .unix(planMe.invoice.createTime)
                        .format("YYYY/MM/DD")}
                    </span>
                  </span>
                </div>
              </Col>
              <Col span={8}>
                <div className="plans-date-container">
                  <span className="plans-font-date-buy-container">
                    expireTime :{" "}
                    <span>
                      {moment
                        .unix(planMe.invoice.expireTime)
                        .format("YYYY/MM/DD")}
                    </span>
                  </span>
                </div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col span={8}>
                <span className="plans-font-name">No purchased plan yet!</span>
              </Col>
            </Row>
          )}
        </Card>
      </Col>
      <Divider
        style={{
          color: "white",
          margin: "50px 0 20px 0",
        }}
      >
        Availables Plans
      </Divider>
      <Col className="column-plans-container" span={24}>
        <Row justify="center" gutter={[20, 10]}>
          {plans &&
            plans.map((item, index) => {
              console.log(item)
              return (
                <Col key={index} xs={24} sm={24} md={20} lg={10} xl={6}>
                  <Card
                    bodyStyle={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      padding: "10px",
                    }}
                    className="plan-card"
                  >
                    <Row justify="center">
                      <span className="plan-card-title">{item.name}</span>
                    </Row>
                    <div className="plan-card-content-container">
                      <ul className="plan-card-content-font">
                        {item.features.split("\n").map((element) => {
                          return <>{<li>{element}</li>}</>;
                        })}
                      </ul>
                    </div>
                    <div className="plan-details-container">
                      <Col className="plan-limit-time" span={12}>
                        <span>Time Limit</span>
                        <span className="plan-limit">
                          {item.value === "Free" ? "unlimited" : "year"}
                        </span>
                      </Col>
                      <Divider
                        type="vertical"
                        style={{
                          height: "100%",
                          margin: "0",
                        }}
                      />
                      <Col className="plan-price" span={12}>
                        <span>Price</span>
                        <span className="plan-value">{item.value}</span>
                      </Col>
                    </div>
                    {item.status > 1 ? (
                      <Button
                        type="primary"
                        onClick={() => {
                          buyPlan(item.id);
                        }}
                        loading={
                          indexPlan === item.id ? (
                            loadingBuy ? (
                              <Loading3QuartersOutlined spin />
                            ) : (
                              false
                            )
                          ) : (
                            false
                          )
                        }
                      >
                        Buy this Plan
                      </Button>
                    ) : null}
                  </Card>
                </Col>
              );
            })}
        </Row>
      </Col>
    </Row>
  );
}
